module.exports = __webpack_public_path__ + "img/英文装饰@2x.a43af7d8.png";